module.exports = __webpack_public_path__ + "img/logo-20.417ad823.png";